module.exports = __webpack_public_path__ + "img/far_fa-bullhorn@1x.7a496814.svg";